import React from "react";
import HeroSection from "./HeroSection";
import DonationForm from "./DonationForm";

const Donate = () => {
  return (
    <div>
      <HeroSection />
      <DonationForm />
    </div>
  );
};

export default Donate;
